<div class="releaseOrder">
    <ng-container>
        <ng-container>
            <div class="title">
                <div class="t1">
                    <span> Enter Movement Details </span>
                    <span class="desc">Enter vessel details</span>
                </div>
            </div>
            <div class="inputs" fxLayout="row wrap">
                <ng-container>
                    <app-text-field [isMultiline]="false" [isEditable]="true" [label]="'Vessel*'"
                                    fxFlex="12em" fxLayout="column" [(ngModel)]="vessel"
                                    [required]="true" [name]="'voyage'">
                    </app-text-field>
                    <!--                    <app-mat-auto-search [isEditable]="true" [label]="'Vessel*'"-->
                    <!--                                         [displayField]="'vessel_name'" [name]="'vessel'"-->
                    <!--                                         [searchable]="true"-->
                    <!--                                         [(ngModel)]="vessel" [setSearchValue]="true"-->
                    <!--                                         (ngModelChange)="onVesselChange($event)"-->
                    <!--                                         [idField]="'id'" [options]="vesselList"-->
                    <!--                                         [labelItemTemplate]="reqSelectedItem"-->
                    <!--                                         [itemTemplate]="reqItem" fxFlex="12em" fxLayout="column"-->
                    <!--                                         [tooltipIcon]="true" [tooltipName]="'Select Vessel'">-->
                    <!--                    </app-mat-auto-search>-->
                </ng-container>

                <ng-container>
                    <app-text-field [isMultiline]="false" [isEditable]="true" [label]="'Voyage'"
                                    fxFlex="12em" fxLayout="column" [(ngModel)]="voyage"
                                    [required]="true" [name]="'voyage'">
                    </app-text-field>
                    <!--                    <app-mat-auto-search [isEditable]="true" [label]="'Voyage*'"-->
                    <!--                                         [displayField]="'voyage_name'" [name]="'voyage'"-->
                    <!--                                         [searchable]="true"-->
                    <!--                                         [(ngModel)]="voyage" [setSearchValue]="true"-->
                    <!--                                         [idField]="'id'" [options]="voyageList"-->
                    <!--                                         [labelItemTemplate]="reqSelectedItem"-->
                    <!--                                         [itemTemplate]="reqItem" fxFlex="12em" fxLayout="column"-->
                    <!--                                         [tooltipIcon]="true" [tooltipName]="'Select Voyage'">-->
                    <!--                    </app-mat-auto-search>-->
                </ng-container>
                <ng-container>
                    <app-date-field [isEditable]="true" [label]="'POL ETA*'" fxFlex="12em"
                                    fxLayout="column"
                                    [(ngModel)]="polEta" (ngModelChange)="dateChange($event)">
                    </app-date-field>
                </ng-container>
                <ng-container>
                    <app-date-field [isEditable]="true" [label]="'POL ETD*'" fxFlex="12em"
                                    fxLayout="column"
                                    [(ngModel)]="polEtd" (ngModelChange)="dateChange($event)">
                    </app-date-field>
                </ng-container>
                <ng-container>
                    <app-date-field [isEditable]="true" [label]="'POD ETA*'" fxFlex="12em"
                                    fxLayout="column"
                                    [(ngModel)]="podEta" (ngModelChange)="dateChange($event)">
                    </app-date-field>
                </ng-container>
            </div>
            <button class="loadingBtn sleekBtn Save" mat-raised-button
                    (click)="saveOrder()">
                <span *ngIf="!disableSaveButton">Save</span>
                <div *ngIf="disableSaveButton" class="p03">
                    <i class="flaticon-loading spin"></i>
                    <span>Saving...</span>
                </div>
            </button>
        </ng-container>
    </ng-container>
</div>

<ng-template #reqItem let-item let-index>
    <div fxFlex="100" fxLayout="column" class="managerListShow">
        <span class="fullname">
            {{ item.vessel_name }}
        </span>
        <!--        <span class="email">-->
        <!--            Qty: {{ item.quantity }}-->
        <!--        </span>-->
    </div>
</ng-template>

<ng-template #reqSelectedItem let-item>
    {{ item.vessel_name }}
</ng-template>

<ng-template #reqItemVoyage let-item let-index>
    <div fxFlex="100" fxLayout="column" class="managerListShow">
        <span class="fullname">
            {{ item.voyage_name }}
        </span>
        <!--        <span class="email">-->
        <!--            Qty: {{ item.quantity }}-->
        <!--        </span>-->
    </div>
</ng-template>

<ng-template #reqSelectedItemVoyage let-item>
    {{ item.voyage_name }}
</ng-template>
